import { useMemo } from 'react'
import {
    addGtmPrefix,
    getActiveAbTestConfig,
    getPatternByPercentage,
} from '../config/abTest/abTestConfig'
import { appendHandoffSuffix } from '../config/abTest/handoffAbTest'
import { getAbValueFromCookie } from '../utils/abTestUtils'

interface UseAbTestGtmProps {
    abValue?: number
    currentPath?: string
}

interface GtmLabels {
    dataClickLabel: (_originalLabel: string) => string
    dataViewLabel: (_originalLabel: string) => string
}

export const useAbTestGtm = ({
    abValue = getAbValueFromCookie(),
    currentPath = typeof window !== 'undefined'
        ? window.location.pathname + window.location.search
        : '/',
}: UseAbTestGtmProps = {}): GtmLabels => {
    const testPattern = useMemo(() => {
        const activeConfig = getActiveAbTestConfig(currentPath)
        if (!activeConfig) return 'A'
        return getPatternByPercentage(abValue, activeConfig.patterns)
    }, [abValue, currentPath])

    const gtmLabels = useMemo(
        () => ({
            dataClickLabel: (originalLabel: string): string => {
                return appendHandoffSuffix(
                    addGtmPrefix(originalLabel, currentPath, testPattern),
                    currentPath
                )
            },

            dataViewLabel: (originalLabel: string): string => {
                return appendHandoffSuffix(
                    addGtmPrefix(originalLabel, currentPath, testPattern),
                    currentPath
                )
            },
        }),
        [testPattern, currentPath]
    )

    return gtmLabels
}
